import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import {
  FavoriteFilterSearchInterface,
  SearchType,
} from "src/app/core/interfaces/favorite-interface";
import { VideoSearchStore } from "../store/video-search-store";
import { JobSearchStore } from "../store/job-search-store";
import { MobilitySearchStore } from "../store/mobility-search-store";
import { JourneySearchStore } from "../store/journey-search-store";
import {
  FilterSet,
  FilterSetType,
} from "src/app/core/interfaces/filter-interface";

@Injectable({
  providedIn: "root",
})
export class FavoriteSearchApplierService {
  private readonly videoStore = inject(VideoSearchStore);
  private readonly jobStore = inject(JobSearchStore);
  private readonly mobilityStore = inject(MobilitySearchStore);
  private readonly journeyStore = inject(JourneySearchStore);
  private readonly router = inject(Router);

  async applyFavoriteSearch(
    favoriteFilter: FavoriteFilterSearchInterface
  ): Promise<void> {
    const { searchType, research } = favoriteFilter;

    switch (searchType) {
      case SearchType.VideoSearch:
        this.applyVideoFilters(research.selectedFilters);
        await this.router.navigate(["/mobility/videos-search"]);
        break;

      case SearchType.JobSearch:
        this.applyJobFilters(
          research.selectedFilters,
          research.locationSearchValue
        );
        await this.router.navigate(["/mobility/jobs-search"]);
        break;

      case SearchType.MobilityReferentSearch:
        this.applyMobilityFilters(
          research.selectedFilters
        );
        await this.router.navigate(["/mobility/referents-search"]);
        break;

      case SearchType.JourneySearch:
        this.applyJourneyFilters(research.selectedFilters);
        await this.router.navigate(["/journey"]);
        break;
    }
  }

  private applyVideoFilters(selectedFilters: FilterSet[]): void {
    const branchesFilter = selectedFilters.find(
      (f) => f.filterSetType === FilterSetType.Sector
    );
    const activitiesFilter = selectedFilters.find(
      (f) => f.filterSetType === FilterSetType.Activity
    );

    this.videoStore.setFiltersSelected(
      branchesFilter || null,
      activitiesFilter || null
    );
  }

  private applyJobFilters(
    selectedFilters: FilterSet[],
    locationSearchValue?: string
  ): void {
    const locationFilter = selectedFilters.find(
      (f) => f.filterSetType === FilterSetType.GeographicalLocation
    );
    const branchesFilter = selectedFilters.find(
      (f) => f.filterSetType === FilterSetType.Sector
    );
    const activitiesFilter = selectedFilters.find(
      (f) => f.filterSetType === FilterSetType.Activity
    );

    this.jobStore.setFiltersSelected(
      locationFilter || null,
      branchesFilter || null,
      activitiesFilter || null,
      locationSearchValue || null
    );
  }

  private applyMobilityFilters(
    selectedFilters: FilterSet[]
  ): void {
    const locationFilter = selectedFilters.find(
      (f) => f.filterSetType === FilterSetType.GeographicalLocation
    );
    const activitiesFilter = selectedFilters.find(
      (f) => f.filterSetType === FilterSetType.Activity
    );

    this.mobilityStore.setFiltersSelected(
      locationFilter || null,
      activitiesFilter || null
    );
  }

  private applyJourneyFilters(selectedFilters: FilterSet[]): void {
    const locationFilter = selectedFilters.find(
      (f) => f.filterSetType === FilterSetType.GeographicalLocation
    );
    const branchesFilter = selectedFilters.find(
      (f) => f.filterSetType === FilterSetType.Sector
    );
    const activitiesFilter = selectedFilters.find(
      (f) => f.filterSetType === FilterSetType.Activity
    );

    this.journeyStore.setFiltersSelected(
      locationFilter || null,
      branchesFilter || null,
      activitiesFilter || null
    );
  }
}
